import { Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
import EirActionModal from '../eir-action-modal/EirActionModal';
import DropDownMenu from '../eir-dropdown-menu/DropDownMenu';
import MobileDropDownMenu from '../eir-dropdown-menu/MobileDropDownMenu';
import { formatAddress } from '../eir-broadband/Broadband.util';
import styles from './styles';
import fetchInfo from '../../../util/fetchModalData';
import { setJourneyPicker } from '../eir-journey-picker/journeyPicker.util';

const SubscriptionSelectionModal = ({
  titleName,
  mobile,
  subscriptions,
  disableAltcta,
  setSubscriptionId,
  openAbondonModal,
  clearJourney,
  setClearJourney,
  setChangeSubs,
  mobileSubscription,
  changeOfferJourney,
  openKeepNumberCheck,
  customerEligibility,
  graphql,
  setShowSubscriptionModal,
}) => {
  // eslint-disable-next-line
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const { publicRuntimeConfig } = getConfig();
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);
  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: mobile
          ? 'mw-eir-action-modals-tailor-exp-mb'
          : 'mw-eir-action-modals-tailor-exp-bb',
      });

      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  const numbers = [];
  subscriptions?.map(subscription =>
    numbers.push({
      value: subscription.id,
      label: subscription.id,
      msisdn: subscription?.servicesForSubscription[0]?.msisdn,
      addressInfo: formatAddress(subscription?.addressInfo, subscription?.servicesForSubscription),
      changeOffer: subscription?.coEligiblity?.contractRenewal,
      totalAmountVatIncluded:
        subscription?.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded,
    })
  );

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={open}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      title={`Hi ${titleName},${cmsCollectionData?.attributes?.title}`}
      description={
        <>
          <Typography sx={styles(theme).description}>
            {`${
              cmsCollectionData?.attributes?.firstHalfDescription
                ? cmsCollectionData?.attributes?.firstHalfDescription
                : ''
            }
            ${
              cmsCollectionData?.attributes?.secondHalfDescription
                ? cmsCollectionData?.attributes?.secondHalfDescription
                : ''
            }
            `}
          </Typography>
          {mobileSubscription ? (
            <MobileDropDownMenu numbers={numbers} changeOfferJourney={changeOfferJourney} />
          ) : (
            <DropDownMenu
              setSubscriptionId={setSubscriptionId}
              numbers={numbers}
              openAbondonModal={openAbondonModal}
              clearJourney={clearJourney}
              setClearJourney={setClearJourney}
              setChangeSubs={setChangeSubs}
            />
          )}
        </>
      }
      altcta={
        disableAltcta
          ? ''
          : [
              {
                text: (
                  <Button
                    variant='altCta'
                    sx={styles(theme).altCtaTextButton}
                    aria-label='Or add a new mobile'
                  >
                    Or add a new mobile
                  </Button>
                ),
                subText: '»',
                action: () =>
                  setJourneyPicker({
                    graphql,
                    openKeepNumberCheck,
                    customerEligibility,
                    setShowSubscriptionModal,
                    addNewMobileFromSubscriptionModal: true,
                  }),
              },
            ]
      }
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      load={load}
    />
  );
};

export default SubscriptionSelectionModal;
